import { render, staticRenderFns } from "./TeamMemberList.vue?vue&type=template&id=4b0017ba&scoped=true"
import script from "./TeamMemberList.vue?vue&type=script&lang=js"
export * from "./TeamMemberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0017ba",
  null
  
)

export default component.exports